import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import AttendanceAnalytics from './AttendanceAnalytics';

export default function StudentProfile() {
    const { studentId } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Extract ID from format "stu_123" if needed, otherwise use direct
        const id = studentId.startsWith('stu_') ? studentId.split('_')[1] : studentId;

        fetch(`/api/students/${id}/attendance-summary`)
            .then(res => res.json())
            .then(data => {
                setData(data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, [studentId]);

    if (loading) return <div className="p-8">Loading profile...</div>;
    if (!data) return <div className="p-8 text-red-500">Student not found</div>;

    const { student, overall, monthly, subjects } = data;

    return (
        <div className="space-y-6 max-w-5xl mx-auto">
            <button
                onClick={() => navigate(-1)}
                className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
            >
                <ArrowLeft size={20} />
                <span>Back to Directory</span>
            </button>

            {/* Header Profile Card */}
            <AttendanceAnalytics
                student={student}
                overall={overall}
                monthly={monthly}
                subjects={subjects}
            />
        </div>
    );
}
